var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHideOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4821_150735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03405 6.90167C12.9721 2.8216 22.9279 3.93947 29.7614 10.26C30.0736 10.5488 30.0796 11.0377 29.7782 11.3372L28.1732 12.9295C27.8854 13.215 27.4223 13.2216 27.1232 12.9473C21.9379 8.19688 14.6137 7.04776 8.39348 9.49814L5.03405 6.90167ZM2.29633 8.5778C1.58444 9.09025 0.896983 9.65098 0.238554 10.26C-0.0736336 10.5488 -0.0797274 11.0377 0.222148 11.3372L1.82715 12.9295C2.11496 13.2155 2.57809 13.2216 2.87715 12.9473C3.68039 12.2115 4.535 11.562 5.42891 10.9989L2.29633 8.5778ZM8.63525 13.4771C7.52167 14.0258 6.46582 14.7274 5.4998 15.5817C5.17637 15.8677 5.16605 16.3641 5.47308 16.6669L7.08746 18.2602C7.36871 18.5377 7.82152 18.5564 8.12105 18.2977C9.30467 17.2745 10.6657 16.5597 12.0972 16.1528L8.63525 13.4771ZM16.6473 15.8775C18.5346 16.1733 20.3549 16.9804 21.8784 18.2977C22.1779 18.5564 22.6307 18.5381 22.912 18.2602L24.5264 16.6669C24.8339 16.3641 24.8231 15.8672 24.5001 15.5817C21.0077 12.4932 16.3462 11.4033 12.0287 12.3078L16.6473 15.8775ZM12 22.5C12 20.843 13.3429 19.5 15 19.5C16.657 19.5 18 20.843 18 22.5C18 24.157 16.657 25.5 15 25.5C13.3429 25.5 12 24.157 12 22.5Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8688 25.3425L0.289506 4.02675C-0.0372165 3.77268 -0.0962797 3.30159 0.157786 2.97439L1.07842 1.78985C1.33249 1.46266 1.80406 1.40359 2.13125 1.65813L29.7105 22.9739C30.0372 23.2279 30.0963 23.699 29.8422 24.0262L28.9216 25.2108C28.6675 25.5379 28.1959 25.5965 27.8688 25.3425Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4821_150735",
    x: 0,
    y: 0,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4821_150735"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideOffline);
export default __webpack_public_path__ + "static/media/hide_offline.eb5b88cf8654caa08e03377356f0f0bf.svg";
export { ForwardRef as ReactComponent };